import { render, staticRenderFns } from "./mogi.vue?vue&type=template&id=2e4c4ea6&"
import script from "./mogi.vue?vue&type=script&lang=js&"
export * from "./mogi.vue?vue&type=script&lang=js&"
import style0 from "./mogi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports